// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3jcqo","content":"styles_content__28nYG","checkbox":"styles_checkbox__-6Vn5","checkboxLabel":"styles_checkboxLabel__PLY5r"};